import envConfig from "../../config/envConfig";

export const parentRegisterSuccess = ({ parentName, parentEmail }) => {
  const subject =
    "Welcome to Practido - Your Registration is Successful 🎉";
  const emailBody = `
Dear <strong>${parentName}</strong>,

<p>
We are thrilled to welcome you and your child to the Practido community! <br>
Your registration was successful, and we're excited to support your child's academic journey.
</p>
<p>
Important Information:<br>
User Login Emil: <strong>${parentEmail}</strong><br>
Support: If you have any questions or need assistance, our support team is here to help. 
You can reach us at <strong>${envConfig.supportEmail}</strong>.
</p>

<p>
We're committed to providing the best educational experience for your child. <br>
Stay tuned for updates, tips, and exclusive content to make the most out of Practido Online Olympiad 2024.<br>
Thank you for choosing us. Together, let's unlock your child's full potential!
</p>

<p>
Best regards,<br>
Team Practido.
</p>

<p>
Follow us on social media : <br>
<a href="${envConfig.facebookLink}">
  <img
    src="${envConfig.appUrl}img/social/fb.png"
    alt="practido facebook link"
  />
</a>
<a href="${envConfig.instagramLink}">
  <img
    src="${envConfig.appUrl}img/social/insta.png"
    alt="practido instagram link"
  />
</a>
<a href="${envConfig.twitterLink}">
  <img
    src="${envConfig.appUrl}img/social/tw.png"
    alt="practido twitter link"
  />
</a>
</p>
<p>


<p><strong>Download Practido App</strong><br/>
Start practicing right away on your phone:</p>

<p>
Android App - <a href="https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice">https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice</a><br/>
iOS App - <a href="https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468">https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468</a>
</p>

<p>We’re excited to support your child’s learning journey.<br/>
If you face any issue, just reply to this email or reach us at <a href="mailto:hello@practido.com">hello@practido.com</a>.</p>

<p>
- Thanks & Regards<br/>
Team Practido (Developed by Naskay)
</p>
  `;

  return { subject, emailBody };
};
